import { EditorStarterItem } from '../item-type';
import { GroupItem } from './group-item-type';

/**
 * 컴포지션 절대좌표 (x, y) 위에 있는 그룹 멤버 id 를 찾는다.
 *
 * children 순서는 z-order(0=배경 → 끝=전경)이므로 뒤에서부터(역순) 순회해
 * 전경 멤버를 우선 반환한다. 겹친 영역은 위에 보이는(전경) 멤버가 잡힌다.
 *
 * - 맞은 멤버가 없으면(빈 영역) null.
 * - items 에 없는 childId 는 방어적으로 무시한다.
 * - bbox 는 멤버의 left/top/width/height(절대좌표)를 그대로 쓴다(그룹 children 은 crop 없음).
 */
export const hitTestGroupMember = (
  group: GroupItem,
  items: Record<string, EditorStarterItem>,
  x: number,
  y: number,
): string | null => {
  for (let i = group.children.length - 1; i >= 0; i--) {
    const childId = group.children[i];
    if (childId == null) continue;
    const child = items[childId];
    if (!child) continue;
    if (
      x >= child.left &&
      x <= child.left + child.width &&
      y >= child.top &&
      y <= child.top + child.height
    ) {
      return childId;
    }
  }
  return null;
};
